"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.IconHeader = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var verdigris_1 = require("@codametrix/verdigris");
var IconHeader = function (props) {
    var svgIconName = props.svgIconName, svgIconClass = props.svgIconClass, svgTitleText = props.svgTitleText, className = props.className, header = props.header, spreadable = __rest(props, ["svgIconName", "svgIconClass", "svgTitleText", "className", "header"]);
    var classes = (0, classnames_1["default"])('icon-divider-title', className);
    return (
    //@ts-ignore
    (0, jsx_runtime_1.jsxs)("div", __assign({}, spreadable, { className: "icon-divider" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: classes }, { children: [(0, jsx_runtime_1.jsx)(verdigris_1.BiomeIcon, { iconName: svgIconName, iconSize: "20", iconClass: svgIconClass, titleText: svgTitleText }), (0, jsx_runtime_1.jsx)("h5", { children: header })] })), (0, jsx_runtime_1.jsx)("div", { className: "divider" })] })));
};
exports.IconHeader = IconHeader;
IconHeader.displayName = 'IconHeader';
//# sourceMappingURL=icon-header.js.map